import { View } from "@/components/ui";
// import { Link } from "@/components/shared/link";
// import { ArrowLeft } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { UpdateContactForm } from "../UpdateContactForm";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import type { UpdateContactProps } from "@/types/profile";

export const UpdateContactScreen = ({
  onSubmit,
  updateContactLoading,
  showTooltip,
}: UpdateContactProps) => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View>
      <View className="static flex flex-row items-center justify-between border-b md:mb-8 md:pb-4">
        <View className="flex flex-row items-center gap-2 p-4 md:p-0">
          {/* CONSISTENECY PROBLEM <Link href="/profile/contacts">
            <ArrowLeft className="visible size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:px-3 md:py-2"
            onClick={() => push({ pageKey: "contacts" })}
          />
          <Typography variant="label-md">Update Contact</Typography>
        </View>
      </View>

      <UpdateContactForm
        onSubmit={onSubmit}
        updateContactLoading={updateContactLoading}
        showTooltip={showTooltip}
      />
    </View>
  );
};
